import { createContext } from 'react';
import { v4 as uuid } from 'uuid';
import { Base_URL } from '../constants/api';
import { buildIeltsDraftKey, loadIeltsDraftFromBrowser, saveIeltsDraftToBrowser } from './ieltsDraftStorage';

export const IeltsAttemptContext = createContext(null);

export async function startIeltsSection({ testId, section, draftId, draftKey, launchGrant, restoreLocal = false }) {
  const baseKey = buildIeltsDraftKey({ scope: 'sectional', section, testId });
  const identity = {
    testId, section, scope: 'sectional',
    ...(draftId ? { draftId } : { draftKey: draftKey || `${baseKey}:${uuid()}` }),
  };
  const response = await fetch(`${Base_URL}/app/users/ielts-tests/drafts/start`, {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-Test-Launch-Token': launchGrant },
    body: JSON.stringify(identity),
  });
  const data = await response.json();
  if (!response.ok || data?.responseCode !== 200 || !data?.response?.id) {
    const error = new Error(data?.message || 'Unable to start this IELTS test. Please retry.');
    error.errorCode = data?.errorCode;
    throw error;
  }
  const draft = data.response;
  const result = { ...identity, draftId: draft.id, draftKey: draft.draft_key || identity.draftKey, accessRevision: draft.access_revision };
  const local = loadIeltsDraftFromBrowser(baseKey);
  if (restoreLocal && local?.state && !local.draftId && !local.draftKey) {
    saveIeltsDraftToBrowser(baseKey, { ...local, ...result, updatedAt: new Date().toISOString() });
    return result;
  }
  if ((Number(local?.draftId) === Number(result.draftId) || local?.draftKey === result.draftKey)
    && Date.parse(local?.updatedAt) > (Date.parse(draft.updated_at) || 0)) {
    return result;
  }
  saveIeltsDraftToBrowser(baseKey, {
    ...result,
    updatedAt: draft.updated_at,
    state: { answers: draft.answers_json || {}, currentStep: draft.current_step || {}, timeState: draft.time_state_json || {}, audioState: draft.audio_state_json || {} },
  });
  return result;
}
